import { render, staticRenderFns } from "./BaseNavDetailAKM.vue?vue&type=template&id=46dfc870"
import script from "./BaseNavDetailAKM.vue?vue&type=script&lang=js"
export * from "./BaseNavDetailAKM.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports